import { EVENTS } from 'sh-www/constants/environment';

/**
 * In the React Native context, we need to track page transitions in order to properly handle
 * the hardware back button on Android. Since the Webview's onNavigationStateChange callback
 * is not fired on SPA route changes, we are wrapping the pushState and replaceState functions
 * with versions that will notify React Native so that we can account for them.
 */
export const initialize = () => {
  if (!window.ReactNativeWebView) {
    return;
  }

  (function notifyOfHistoryChanges() {
    function addReactNativeNotifier(fn) {
      return function functionWithReactNativeNotifier() {
        window.ReactNativeWebView.postMessage(`{
            "type": "${EVENTS.SPA_NAVIGATION_STATE_CHANGE}"
          }`);
        return fn.apply(this, arguments);
      };
    }

    history.replaceState = addReactNativeNotifier(history.replaceState);
    history.pushState = addReactNativeNotifier(history.pushState);
  })();
};

export default {
  initialize,
};
